import React from 'react';
import EntityModal, { EntityConfig } from '../ui/EntityModal';

interface FolderModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (folderData: { name: string }) => Promise<void>;
  mode: 'create' | 'edit';
  initialData?: { name: string };
}

const folderConfig: EntityConfig = {
  entityName: 'folder',
  titles: {
    create: 'Create New Folder',
    edit: 'Edit Folder',
  },
  description: {
    create: 'Create a new folder in the root directory',
  },
  fieldLabel: 'Folder Name',
  placeholder: 'Enter folder name',
  helperText: 'Maximum 255 characters. Cannot contain: < > : " / \\ | ? *',
  validation: (name: string) => {
    if (name.length > 255) {
      return 'Folder name must be 255 characters or less';
    }

    const invalidChars = /[<>:"/\\|?*]/;
    if (invalidChars.test(name)) {
      return 'Cannot contain: < > : " / \\ | ? *';
    }

    return null;
  },
};

const FolderModal: React.FC<FolderModalProps> = (props) => {
  return <EntityModal {...props} config={folderConfig} />;
};

export default FolderModal;
